import React, { useEffect, useRef } from "react";
import { Nav } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import {
  FaTachometerAlt,
  FaLeaf,
  FaSeedling,
  FaClock,
  FaBox,
  FaUsersCog,
} from "react-icons/fa";
import "../../styles/custom.css";
import "../../styles/sidebar.css";

const Sidebar = ({ mobileOpen, setMobileOpen, isAdmin }) => {
  const sidebarRef = useRef(null);

  // Close sidebar when clicking outside on mobile
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target) &&
        window.innerWidth <= 768 &&
        mobileOpen
      ) {
        setMobileOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [mobileOpen, setMobileOpen]);

  return (
    <aside
      ref={sidebarRef}
      className={`sidebar ${mobileOpen ? "mobile-open" : ""}`}
    >
      <Nav className="flex-column p-3">
        <NavLink to="/" className="nav-link" title="Dashboard">
          <FaTachometerAlt size={18} />
          <span className="nav-label">Live Dashboard</span>
        </NavLink>
        <NavLink to="/coriander" className="nav-link" title="Coriander">
          <FaLeaf size={18} />
          <span className="nav-label">Coriander</span>
        </NavLink>
        <NavLink to="/turmeric" className="nav-link" title="Turmeric">
          <FaSeedling size={18} />
          <span className="nav-label">Turmeric</span>
        </NavLink>
        <NavLink to="/rtc" className="nav-link" title="RTC">
          <FaClock size={18} />
          <span className="nav-label">RTC</span>
        </NavLink>
        <NavLink to="/packaging" className="nav-link" title="Packaging">
          <FaBox size={18} />
          <span className="nav-label">Packaging</span>
        </NavLink>

        {/* Admin-only navigation */}
        {isAdmin && (
          <NavLink to="/admin/users" className="nav-link" title="User Management">
            <FaUsersCog size={18} />
            <span className="nav-label">User Management</span>
          </NavLink>
        )}
      </Nav>
    </aside>
  );
};

export default Sidebar;
